import { Outlet, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Navbar from "@/widgets/layout/Navbar"
import Footer from "@/widgets/layout/Footer"
import ContactWidget from "@/widgets/layout/ContactWidget"

export default function MainLayout() {
  const { t } = useTranslation()
  const { pathname, search } = useLocation()
  const isEmbedMode = new URLSearchParams(search).get("embed") === "1"
  const isHome = pathname === "/"

  return (
    <div className="min-h-screen font-sans flex flex-col bg-lib-bg text-lib-text">
      {isEmbedMode ? null : (
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 z-[60] px-4 py-2 rounded-md bg-lib-card text-lib-accent text-sm font-semibold shadow-md border border-lib-accent"
        >
          {t("common.skipToContent")}
        </a>
      )}
      {isEmbedMode ? null : <Navbar />}
      <main
        id="main-content"
        tabIndex={-1}
        className={`flex-1 w-full focus:outline-none ${isEmbedMode || isHome ? "" : "pt-16 md:pt-20"}`}
      >
        <Outlet />
      </main>
      {isEmbedMode ? null : <Footer />}
      {isEmbedMode ? null : <ContactWidget />}
    </div>
  )
}
